<template>
    <div>
        <div class="container-fluid mb-4">
            <div class="button-navigation hide-scrollbar">
                <button class="btn" :class="[navMove === index ? 'active-navigation' : '']" @click="navMove = index;"  v-for="(item, index) in navButtons" :key="index">
                    {{ item.name }}
                </button>
                
            </div>
            <div class="white-bg get-plan-section" v-if="navMove == 0">
                <div class="top-headings">
                    <h4 class="headings">Property pricing and Billing</h4>
                    <h6 class="subheadings d-none d-sm-block">Here are all the tenant informations on your property, click to add new tenant or request rent from tenant</h6>
                </div>

                <!-- <div>
                    <button class="btn sheltaBtn">Get a new plan</button>
                </div> -->
            </div>

            <div class="plans-holder mt-3 mb-4" v-if="navMove == 0">
                <div class="row">
                    <div class="col-md-3"  v-for="(item, index) in plans" :key="index">
                        <div class="plans-item white-bg">
                            <div class="d-flex justify-content-between">
                                <h4>{{item.name}}</h4>
                                <!-- <button class="btn blackBtn btn-height">Current Plan</button> -->
                            </div>

                            <h6>From</h6>
                            <h4> {{ item.id == 1 ? "₦0" : item.id == 2 ? '₦100,000/yearly' : item.percentage + '%'  }} </h4>
                            <p>{{item.description}}</p>

                            <div>
                                <div class="text-left mb-2" v-for="feature in item.plan_features" :key="feature">
                                    <span>
                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect y="0.304688" width="22.1538" height="22.1538" rx="11.0769" fill="#F5F8FF"/>
                                            <g clip-path="url(#clip0_9450_17293)">
                                            <path d="M18.0005 10.7471V11.3841C17.9996 12.877 17.5162 14.3296 16.6223 15.5253C15.7284 16.7211 14.472 17.5958 13.0403 18.0191C11.6087 18.4424 10.0786 18.3915 8.67816 17.8742C7.27777 17.3568 6.08213 16.4006 5.26958 15.1482C4.45702 13.8958 4.07108 12.4143 4.1693 10.9246C4.26753 9.43492 4.84467 8.01691 5.81464 6.88204C6.78462 5.74718 8.09546 4.95626 9.55166 4.62725C11.0079 4.29824 12.5314 4.44877 13.8951 5.05638" stroke="#7593FF" stroke-width="1.38462" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M18 5.84375L11.0769 12.7738L9 10.6968" stroke="#7593FF" stroke-width="1.38462" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0_9450_17293">
                                            <rect width="16.6154" height="16.6154" fill="white" transform="translate(2.76953 3.07422)"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                    <small>{{feature}}</small>
                                </div>
                               
                            </div>

                            <div class="baseBtn">
                                <!-- greyBtnOff -->
                                <button class="btn navyblueBtn mt-auto">{{item.name}} plan</button>
                            </div>



                        </div>
                    </div>
                    
                </div>
            </div>

            <div class="mt-3" v-if="navMove == 1">
                <div class="white-bg">
                    <div class="propPlansTopHolder">
                        <div class="top-headings">
                            <h4 class="headings">My Property Plans</h4>
                            <h6 class="subheadings d-none d-sm-block">Here are all property and the plan they are on.</h6>
                        </div>
                        <div>
                            <button class="btn outlinedBtnn" disabled>Learn more about plans</button>
                        </div>
                    </div>

                    <div>
                        <div class="table-holder" style="padding: 0;" v-if="navMove == 1 && !loading" ref="targetSection">
                            <div class="mb-3 col-md-4 pl-0">
                                <input type="text" class="form-control" v-model="search" placeholder="Search with title.">
                            </div>
                            <div class="table-responsive tableList">
                                <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                                    <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Property title</th>
                                            <th scope="col">Property address</th>
                                            <th scope="col">Plan type</th>
                                            <th scope="col">Plat last update</th>
                                            <th scope="col">Plan expiration date</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- v-for="(item, index) in landlords"
                                            :key="index" -->
                                        <tr  v-for="(item, index) in filteredProperties" :key="index">
                                            <td>{{ item.title }}</td>
                                            <td class="text-wrap" style="max-width: 399px; min-width: 200px;">{{ item.address }}</td>
                                            <td>{{item.plan_type}}</td>
                                            <td>{{item.updated_at | moment2}}</td>
                                            <td>{{item.plan_expiry_date | moment2}}</td>
                                            <!-- <td style="color: #0033EA" @click="navigateTo('/dashboard/billing-history')"> -->
                                            <td style="color: #0033EA" @click="openUpdateModal(item)">
                                                <span>Update/Chnage</span>
                                            </td>
                                            <!-- <td></td> -->
                                            <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                                        </tr>  
                                    </tbody>
                                </table>
                                <div v-if="filteredProperties.length == 0" class="empty-state mt-5 mb-5">
                                    <img src="../assets/icons/emptycan-state.svg" alt="empty">
                                    <h5>No available data</h5>
                                </div>
                            </div>

                        </div>
                    </div>
                    <UpdatePlanModal v-if="propPlanData" :planData="propPlanData" @callFunction="refreshProp"></UpdatePlanModal>
                </div>
            </div>

            <div v-if="loadingplans">
                <PageLoader></PageLoader>
            </div>
        </div>
    </div>
</template>

<script>
import '@/assets/styles/custom.scss';
import { Service } from "../store/service";
import moment from "moment";
import Vue from "vue";
const Api = new Service();
import $ from "jquery";
import UpdatePlanModal from "./UpdatePlanModal";
import PageLoader from "./PageLoader";
export default {
    name: "PlansBillings",
    components: {
        // SmallNav
        UpdatePlanModal,
        PageLoader,
    },
    data() {
        return {
            loading: false,
            loadingplans: false,
            navMove: 0,
            plans: [],
            navButtons: [
                { name: 'Price information' },
                { name: 'My current plan' },
            ],
            search: "",
            properties: [],
            propPlanData: "",
            search: "",
        }
    },
    computed: {
        filteredProperties() {
            return this.properties.filter((item) =>
                item.title.toLowerCase().includes(this.search.toLowerCase())
            );
        },
    },
    mounted() {
        this.landlordplans();
        this.fetchLandlordProperties();
    },
    methods: {
        navigateTo(route) {
            return this.$router.push({
                path: route
            });
        },
        openUpdateModal(item) {
            $("#updateplan")
            .addClass("fade")
            .modal("show");
            this.propPlanData = item;
        },
        refreshProp() {
            this.fetchLandlordProperties();
        },
        async landlordplans() {
            this.loadingplans = true;
            await Api.getRequest(`fetch-landlord-plans`)
            .then(data => {
               this.loadingplans = false;
                // console.log("plans", data);
                if(data.data.success) {
                    this.plans = data.data.plans;
                }
                if (data.data.error) {
                    this.$store.commit("setApiFailed", data.data.error);
                    // this.$toast.error(data.data.error);
                }
            }).catch((err) => {
                this.loadingplans = false;
                console.log(err);
                this.$store.commit("setApiFailed", err);
                // this.$toast.error(err);
            });
        },
        async fetchLandlordProperties() {
            this.loadingplans = true;
            try {
                await Api.getRequest(`new-dashboard-landlord-properties`)
                .then(res => {
                    // console.log("Properties", res);
                    this.loadingplans = false;
                    if (res.data.success) {
                    this.properties = res.data.properties;
                    }
                })
                .catch(err => {
                    // console.log(err);
                    this.loadingplans = false;
                    // this.loader = false;
                });
            } finally {
                // console.log("Closed connection");
            }
        },
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        moment2: function(date) {
            return moment(date).format("MMMM Do YYYY");
        },
        moment3: function(date) {
            return moment(date).format("h:mm:ss a");
        },
    }
}
</script>

<style scoped lang="scss">
.active-navigation {
    border-bottom: 2px solid #0033EA;
    border-radius: 0;
}
.get-plan-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.btn-height {
    height: 30px;
}
.plans-item {
    min-height: 459px;
    position: relative;
    margin-bottom: 15px;
    h4 {
        font-family: Lato;
        font-weight: 700;
        font-size: 15.23px;
        line-height: 32px;
        color: #2B3352;
        text-align: left;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 9.69px;
        line-height: 20px;
        color: #555C74;
        text-align: left;
        margin-bottom: 0;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        line-height: 15.23px;
        color: #555C74;
        text-align: left;
    }
    small {
        font-family: Lato;
        font-weight: 500;
        font-size: 11px;
        // line-height: 100%;
        color: #555C74;

    }
    button {
        white-space: nowrap;
    }
}


.baseBtn {
 margin-top: 30px;
 position: absolute;
 bottom: 10px;
 left: 50%;
  transform: translateX(-50%);
}
.greyBtnOff { 
    background: #D2D2D2;
    font-family: Lato;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #333333;
}

.propPlansTopHolder {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media only screen and (max-width: 599px) {
 .get-plan-section {
    display: block;
    button {
        margin-top: 20px;
    }
 }
 
}

</style>